<script setup lang="ts">
import type { BaseItem } from '~/models/Content/BaseItem'
import { computed } from 'vue'
import { useUrlBuilder } from '~/composables/useUrlBuilder'
import LinkOrAnchor from '~/components/utils/LinkOrAnchor.vue'

const { article, index } = defineProps<{ article: BaseItem, index: number }>()

const { buildResourceUrl } = useUrlBuilder()

const url = computed(() => buildResourceUrl(article))
const svgIndex = computed(() => index % 4)
</script>

<template>
  <LinkOrAnchor
    :link="url"
    new-tab
    is-anchor
    class="flex items-center gap-4 font-medium transition-all hover:underline hover:underline-offset-4 focus-visible:ring"
  >
    <svg
      v-if="svgIndex === 0"
      class="size-12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
    >
      <circle
        cx="24"
        cy="24"
        r="24"
        fill="#FF6472"
      />
    </svg>
    <svg
      v-if="svgIndex === 1"
      class="size-12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 55 52"
    >
      <path fill="#5892D0" d="M25.924 1.017a2 2 0 0 1 3.152 0l6.243 7.991a2 2 0 0 0 1.612.769l10.236-.187a2 2 0 0 1 1.975 2.489l-2.441 9.677a2 2 0 0 0 .41 1.779l6.468 7.671a2 2 0 0 1-.707 3.113l-9.252 4.17a2 2 0 0 0-1.134 1.408l-2.085 9.81a2 2 0 0 1-2.844 1.375l-9.169-4.546a2 2 0 0 0-1.776 0l-9.169 4.546a2 2 0 0 1-2.844-1.376l-2.085-9.809a2 2 0 0 0-1.134-1.407l-9.252-4.171a2 2 0 0 1-.707-3.113l6.468-7.671a2 2 0 0 0 .41-1.779L5.858 12.08A2 2 0 0 1 7.834 9.59l10.235.187a2 2 0 0 0 1.612-.769l6.243-7.99Z" />
    </svg>
    <svg
      v-if="svgIndex === 2"
      class="size-12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 52"
    >
      <path fill="#FFB8F2" d="M1.972 33.179c-2.64 2.802-1.255 7.41 2.49 8.294l41.956 9.907c3.746.885 7.045-2.618 5.938-6.304L39.958 3.788c-1.108-3.686-5.79-4.792-8.429-1.99L1.972 33.178Z" />
    </svg>
    <svg
      v-if="svgIndex === 3"
      class="size-12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
    >
      <path fill="#FFDB46" d="M23.756 0a6.441 6.441 0 0 1 6.44 6.441v1.765l1.248-1.248a6.441 6.441 0 0 1 9.109 9.11l-1.248 1.247h1.765a6.44 6.44 0 1 1 0 12.881h-1.765l1.248 1.248a6.442 6.442 0 0 1-9.109 9.11l-1.248-1.248v1.764a6.441 6.441 0 1 1-12.882 0v-1.764l-1.248 1.248a6.442 6.442 0 0 1-9.109-9.109l1.249-1.249H6.44a6.44 6.44 0 1 1 0-12.88h1.766l-1.249-1.25a6.441 6.441 0 0 1 9.11-9.108l1.247 1.248V6.441A6.442 6.442 0 0 1 23.756 0Z" />
    </svg>
    <span class="inline-block max-w-72" v-text="article.title" />
  </LinkOrAnchor>
</template>
